import Splide from "@splidejs/splide";

new Splide('#review-slider', {
    type: 'loop',
    perPage: 2,
    perMove: 2,
    gap: 30,
    drag: 'free',
    arrows: true,
    pagination: true,
    snap: true,
    breakpoints: {
        991: {
            perPage: 1,
            perMove: 1,
        },
    },
}).mount();